import React from 'react';
import BaseModal from 'src/common/components/Modal';
import moment from 'moment';
import 'moment/locale/es';

const ConfirmacionModal = ({ open, setOpen, date, closeAll, cancel, onConfirmDate }) => {
	moment.locale('es');
	var dateTime = moment(date);
	var dateFormat = dateTime.format('dddd D, MMMM YYYY');
	let dateSession = date + ' 00:00:00';

	return (
		<BaseModal
			open={open}
			mainText="Crear Nueva Sesión"
			confirmLabel="Si, crear"
			onConfirm={() => {
				setOpen(false);
				closeAll(false);
				onConfirmDate(dateSession);
			}}
			onClose={() => {
				setOpen(false);
				cancel(new Date());
			}}
			onCancel={() => {
				setOpen(false);
				cancel(new Date());
			}}
		>
			<h5>Desea crear una nueva sesión el día {dateFormat}?</h5>
		</BaseModal>
	);
};

export default ConfirmacionModal;
